import * as yup from 'yup';
import { error } from '../text';

const requiredValidation = yup.string().required(error.required);

const passwordMixed = new RegExp(
  ['(?=.*[a-zA-Z])(?=.*[0-9])[a-zA-Z0-9!-/:-@[-`{-~]{6,}$'].join(''),
);
const emailValidation = yup
  .string()
  .lowercase()
  .required(error.required)
  .email(error.email)
  .max(250, error.below250);

const passwordValidation = yup
  .string()
  .required(error.required)
  .min(6, error.min)
  .max(250, error.below250)
  .matches(passwordMixed, error.mixed);

const LoginPasswordValidation = yup.string().required(error.required);

export const userLoginSchema = yup.object().shape({
  email: emailValidation,
  password: LoginPasswordValidation,
});

export const userInviteMailSchema = yup.object().shape({
  email: emailValidation,
  role: yup.bool().oneOf([true, false], error.required).required(error.required),
});

export const PasswordChangeSchema = yup.object().shape({
  email: yup.string().nullable().notRequired(), // disabledで値を持っていないことになるためnull許可
  password: passwordValidation,
  passwordConfirm: passwordValidation.oneOf([yup.ref('password')], 'パスワードが一致しません'),
});

export const reRegisterPasswordSchema = yup.object().shape({
  email: emailValidation,
});

const imageValidation = yup
  .mixed<File>()
  .test('fileFormat', error.image, value => {
    if (value instanceof File) {
      const supportedFormats = ['jpg', 'jpeg', 'png', 'webp', 'gif', 'svg'];
      const fileExtension = value.name.split('.').pop()?.toLowerCase();
      return supportedFormats.includes(fileExtension || '');
    }
    return true;
  })
  .test('fileSize', error.imageSize, value => {
    if (value instanceof File) {
      return value.size <= 10 * 1024 * 1024; // 10MB以下
    }
    return true;
  });

export const clientStaffEditSchema = yup.object().shape({
  department: yup.string().nullable().required(error.required).max(250, error.below250),
  iconId: yup.string().nullable(),
  icon: imageValidation,
  email: yup.string().nullable(),
  name: requiredValidation.max(250, error.below250),
  role: yup.bool().oneOf([true, false], error.required).required(error.required),
});
